// extracted by mini-css-extract-plugin
export default {"check-box-wrap":"CheckBoxForm_check-box-wrap__F37kb","check-box-btn":"CheckBoxForm_check-box-btn__Uvqu9","check-box-label":"CheckBoxForm_check-box-label__ovNqp"};